export default {
  loading: false,
  approve_lists: [],
  totalCount: 0,
};
